export default __webpack_public_path__ + "static/media/1.851c4885.png";